import React, { Fragment, useEffect, useRef, useState } from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import DragDrop from "../DragDrop/DragDrop";
import ApprovalsScreen from "./ApprovalsScreen";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
import { getAccessSettings } from "../Shared/Utility";
export default function ConditionalHoldApproval() {
  const [showAnimation, setShowAnimation] = useState(false);
  const globalState = useGlobalState();
  const [programList, setProgramList] = useState<any>([]);
  const [quarterList, setQuarterList] = useState<any>([]);

  const [exceptionStatusList, setExceptionStatusList] = useState<any>([
    {
      PID: -1,
      Name: "All",
    },
    {
      PID: 0,
      Name: "In Progress",
    },
    {
      PID: 1,
      Name: "Passed",
    },
    {
      PID: 2,
      Name: "Failed",
    },
  ]);

  const [groupList, setGroupList] = useState<any>([]);

  const [exceptionDataFilter, setExceptionDataFilter] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
    ExceptionStatusID: -1,
    IBBConditionID: -1,
  });

  const [exceptionsData, setExceptionsData] = useState<any>([]);
  const [exceptionsDocuments, setExceptionsDocuments] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  const [popUpMessage, setPopUpMessage] = useState("");
  const [popUpMessageModal, setPopUpMessageModal] = useState(false);

  const [conditionModal, setConditionModal] = useState(false);
  const [conditionData, setConditionData] = useState<any>({});

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = exceptionDataFilter.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = exceptionDataFilter.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = exceptionDataFilter.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = exceptionDataFilter.ProgramID;

    let ExceptionStatusID = params.get("exsid") as any;
    if (ExceptionStatusID && ExceptionStatusID != "")
      ExceptionStatusID = Number(ExceptionStatusID);
    else ExceptionStatusID = exceptionDataFilter.ExceptionStatusID;

    setExceptionDataFilter((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
      ExceptionStatusID: ExceptionStatusID,
    }));

    IBBProgramGetProgramListForScorecard(IBBProgramID);
    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    if (exceptionDataFilter.ProgramID > 0) IBBConditionGetDataForApproval();
  }, [exceptionDataFilter]);

  function IBBProgramGetProgramListForScorecard(IBBProgramID: number) {
    if (IBBProgramID == 0) IBBProgramID = exceptionDataFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = exceptionDataFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setExceptionDataFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }
          }

          setQuarterList(result[2]);
          if (exceptionDataFilter.QuarterID == 0) {
            let QuarterID = result[2][0].PID;
            setExceptionDataFilter((prevState: any) => ({
              ...prevState,
              QuarterID: QuarterID,
            }));
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBConditionGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = exceptionDataFilter.ProgramID;
    object.quarterid = exceptionDataFilter.QuarterID;
    object.pfigroupids = exceptionDataFilter.PFIGroupIDs;
    object.statusid = exceptionDataFilter.ExceptionStatusID;
    object.ibbprogramstageid = 10;
    object.ibbprogramsectionid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBCondition/IBBConditionGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;

          if (result.length > 2) {
            let exceptionsDataLocal = [];
            var filtered = result[0].filter((item: any) => item.Type == 1);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "GATEWAY Conditional Holds",
                Data: filtered,
              });

            var filtered = result[0].filter((item: any) => item.Type == 2);
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "CRITERIA Conditional Holds",
                Data: filtered,
              });

            setExceptionsData(exceptionsDataLocal);
            setExceptionsDocuments(result[1]);
            setRequiredApprovalUser(result[2]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const [dragDropFeaturesModal, setDragDropFeaturesModal] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeConditionalHoldEvidenceFile,
    MaxAllowedFiles: 5,
    UploadType: 1,
    FolderName: "ConditionalHold",
    PTUploadedFiles: [],
  });

  const [showDragDropModal, setShowDragDropModal] = useState(false);

  const [uploadFileListModal, setUploadFileListModal] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [triggerChildModal, setTriggerChildModal] = useState(false);

  function handleDragDropCallbackModal(ChildData: any) {
    setUploadFileListModal(ChildData);
  }

  function SaveFilesModal(ObjectID: any) {
    let uploadFileListArray = [];
    for (let index = 0; index < uploadFileListModal.length; index++) {
      if (!uploadFileListModal[index].AlreadyUploaded) {
        uploadFileListArray.push(uploadFileListModal[index]);
      }
    }

    if (uploadFileListArray && uploadFileListArray.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeaturesModal.ObjectType;
      object.objectid = dragDropFeaturesModal.ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileListArray;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChildModal(!triggerChild);
            let l_response = response.data.Data;

            let uploadFileArray = [];
            for (let index = 0; index < uploadFileListModal.length; index++) {
              if (uploadFileListModal[index].AlreadyUploaded) {
                uploadFileArray.push(uploadFileListModal[index]);
              }
            }
            for (let index = 0; index < l_response.length; index++) {
              uploadFileArray.push(l_response[index]);
            }

            saveAttachmentDataForObjectTypeIDObjectID(
              uploadFileArray,
              ObjectID
            );
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveAttachmentDataForObjectTypeIDObjectID(uploadFileListModal, ObjectID);
    }
  }

  function saveAttachmentDataForObjectTypeIDObjectID(
    uploadedFileList: any,
    ObjectID: any
  ) {
    let object = {} as any;
    object.objecttype =
      AppContext.FileUploadObjectTypeConditionalHoldEvidenceFile;
    object.objectid = ObjectID;
    object.typeid = 0;
    object.filesdata = uploadedFileList;
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/SaveAttachmentDataForObjectTypeIDObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          IBBConditionGetDataForApproval();
        } else {
          console.error("error", response.data.Message);
        }
        setShowDragDropModal(false);
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getAttachmentDataForObjectTypeAndObjectID(
    objecttype: any,
    objectid: any,
    typeid: any
  ) {
    let object = {} as any;
    object.typeid = typeid;
    object.objecttype = objecttype;
    object.objectid = objectid;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PTAttachment/GetAttachmentDataForObjectTypeAndObjectID",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          dragDropFeaturesModal.PTUploadedFiles = [];
          let gridData = response.data.Data;
          let attachments = [] as any;
          if (gridData && gridData[0] && gridData[0].length > 0) {
            for (let i = 0; i < gridData[0].length; i++) {
              // if (gridData[3][i].ObjectID == id) {
              attachments.push({
                ObjectID: gridData[0][i].ObjectID,
                Name: gridData[0][i].Name,
                FileURLDisplay: AppContext.GetFileIconToDisplay(
                  gridData[0][i].FileURLRaw
                ),
                FileURL: gridData[0][i].FileURLRaw,
                AlreadyUploaded: true,
                S3Path: gridData[0][i].S3Path,
                Identifier: gridData[0][i].Identifier,
                Title: gridData[0][i].Title,
                Tags: gridData[0][i].Tags,
              });
              // }
            }
          }
          dragDropFeaturesModal.PTUploadedFiles = attachments;
          setDragDropFeaturesModal((prevState: any) => ({
            ...prevState,
            PTUploadedFiles: attachments,
          }));
        } else {
          console.error("error", response.data.Message);
        }
        setShowAnimation(false);
        setShowDragDropModal(true);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBConditionGetDataForApproval();
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>conditional hold status</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div className="flex-items">
              <select
                value={exceptionDataFilter.ProgramID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                    IBBScorecardID: 0,
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    IBBProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(Number(e.target.value));
                }}
              >
                {programList &&
                  programList.map((item: any, index: any) => (
                    <option value={item.PID} key={"programoption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.QuarterID}
                onChange={(e) => {
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                  globalState.setTopFilterData((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }));
                }}
              >
                {quarterList &&
                  quarterList.map((item: any, index: any) => (
                    <option value={item.PID} key={"quarteroption" + item.PID}>
                      {item.Name}
                    </option>
                  ))}
              </select>

              <select
                value={exceptionDataFilter.ExceptionStatusID}
                onChange={(e) =>
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    ExceptionStatusID: Number(e.target.value),
                  }))
                }
              >
                {exceptionStatusList &&
                  exceptionStatusList.map((item: any, index: any) => (
                    <option
                      value={item.PID}
                      key={"exceptionStatusList" + item.PID}
                    >
                      {item.Name}
                    </option>
                  ))}
              </select>
              <select
                value={exceptionDataFilter.PFIGroupIDs}
                onChange={(e) =>
                  setExceptionDataFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                  }))
                }
              >
                {groupList &&
                  groupList.map((item: any, index: any) => (
                    <option value={item.IBBGroupID} key={"groupoption" + index}>
                      {item.Name}
                    </option>
                  ))}
              </select>
            </div>
          </div>

          <div className="section-table mb-10 exception-up">
            {exceptionsData &&
              exceptionsData.map((item: any, index: any) => (
                <React.Fragment key={item.SectionTypeName}>
                  <span className="buis-head font-16">
                    {item.SectionTypeName}
                  </span>
                  {item.Data &&
                    item.Data.map((itemException: any, indexException: any) => (
                      <React.Fragment key={itemException.IBBConditionID}>
                        <div className="buis-case case-back plr-20">
                          <div className="excep-heading">
                            <span>
                              {itemException.PTOrderBy}.{itemException.Title} -{" "}
                              {itemException.Name}
                            </span>
                            <div className="flex-items">
                              <span>{itemException.Importer}</span>
                            </div>
                          </div>
                          <div className="exception-grid">
                            <div className="exceptions-left">
                              <div className="flex-items buis-head">
                                <span>
                                  Amount:{" "}
                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                    itemException.CurrencyID
                                  )}
                                  {itemException.Amount.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </span>{" "}
                                <span>
                                  Approved Amount:{" "}
                                  {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                    itemException.CurrencyID
                                  )}
                                  {itemException.ApprovedAmount.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </span>{" "}
                                <span
                                  className={`
                               ${itemException.Status == 1 ? "sig-green" : ""}
                               ${itemException.Status == 2 ? "sig-red" : ""}
                          `}
                                >
                                  Status: {itemException.StatusName}
                                </span>
                              </div>
                              <span>
                                <b>Condition:</b>
                              </span>
                              <span className="flex-items">
                                {itemException.ConditionText}
                              </span>
                              <span>
                                <b>Deadline:</b>
                              </span>
                              <div className="flex-items">
                                <span className="spn-text-width">
                                  {moment(itemException.Deadline).format(
                                    "DD/MM/YYYY"
                                  )}
                                </span>
                              </div>
                              <div className="flex-items supp-doc mb-0">
                                <span className="flex-items">
                                  Supporting Documents:
                                  {getAccessSettings(2, 27) > 1 && (
                                    <a
                                      className="btn-primary btngrid"
                                      title="Manage Supporting Documents"
                                      onClick={() => {
                                        setExceptionDataFilter(
                                          (prevState: any) => ({
                                            ...prevState,
                                            IBBConditionID: Number(
                                              itemException.IBBConditionID
                                            ),
                                          })
                                        );

                                        getAttachmentDataForObjectTypeAndObjectID(
                                          AppContext.FileUploadObjectTypeConditionalHoldEvidenceFile,
                                          Number(itemException.IBBConditionID),
                                          0
                                        );
                                      }}
                                    >
                                      <img
                                        src="images/attach.svg"
                                        width={15}
                                        height={15}
                                      />
                                    </a>
                                  )}
                                </span>
                              </div>
                              <>
                                {exceptionsDocuments &&
                                  exceptionsDocuments.map(
                                    (
                                      ItemAttachment: any,
                                      indexAttachment: any
                                    ) => (
                                      <>
                                        {itemException.IBBConditionID ==
                                          ItemAttachment.ObjectID && (
                                          <span
                                            key={
                                              ItemAttachment.ObjectID +
                                              "" +
                                              indexAttachment
                                            }
                                          >
                                            <a
                                              href={ItemAttachment.FileURLRaw}
                                              target="blank"
                                            >
                                              <img
                                                src="images/pdf.svg"
                                                width="40px"
                                                height="40px"
                                              />
                                            </a>
                                          </span>
                                        )}
                                      </>
                                    )
                                  )}
                              </>
                            </div>
                            <div className="pg-importers appr-grid grid-signoff">
                              <div className="appr-main">
                                <div className="exceptions-right">
                                  <div className="req-by">
                                    <div className="req-left">
                                      <span className="req-title show-block">
                                        Requested by
                                      </span>
                                      <span className="req-val">
                                        {itemException.RequestedBy}
                                      </span>
                                    </div>
                                    <div className="req-right"></div>
                                  </div>
                                  <span
                                    className="req-title"
                                    style={{ paddingLeft: 10, marginBottom: 5 }}
                                  >
                                    Operational Approval
                                  </span>
                                  <div className="excp-approval">
                                    <ApprovalsScreen
                                      approvalObjectType={35}
                                      IBBProgramID={
                                        exceptionDataFilter.ProgramID
                                      }
                                      QuarterID={exceptionDataFilter.QuarterID}
                                      IBBProgramSectionID={0}
                                      approvalObjectID={
                                        itemException.IBBConditionID
                                      }
                                      ApprovalTextType={2}
                                      uploadObjectType={
                                        AppContext.FileUploadObjectTypeConditionalHoldApprovalFile
                                      }
                                      requiredApprovalUser={
                                        requiredApprovalUser
                                      }
                                      triggerApprovalParent={
                                        triggerApprovalParent
                                      }
                                    ></ApprovalsScreen>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>

      {showDragDropModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head" style={{ marginBottom: 0 }}>
                <h3>Supporting Documents</h3>
                <a
                  className="close-help"
                  onClick={() => setShowDragDropModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="plr-20 pad-t20">
                <div className="flex-items justify-center">
                  <div className="centre-drop-cl">
                    <div className="drad-drop">
                      <DragDrop
                        ParentFeatures={dragDropFeaturesModal}
                        DragDropCallback={handleDragDropCallbackModal}
                        TriggerChild={triggerChildModal}
                      />
                    </div>
                    <div className="help-btns">
                      <a
                        onClick={() =>
                          SaveFilesModal(exceptionDataFilter.IBBConditionID)
                        }
                      >
                        Save
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {popUpMessageModal && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Message</h3>
                <a
                  className="close-help"
                  onClick={() => setPopUpMessageModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="buis-case plr-20">{popUpMessage}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
